import React from 'react';

import MuiTextField, { OutlinedTextFieldProps } from '@mui/material/TextField';
import clsx from 'clsx';

import { CoreProps } from '../types';
import { withCoreProps } from '../withCoreProps';

export const TextField = withCoreProps<TextFieldProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<TextFieldProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiTextField {...props} variant="outlined" className={clsxClass}>
        {children}
      </MuiTextField>
    );
  },
);

export interface TextFieldProps
  extends Omit<OutlinedTextFieldProps, 'variant'>,
    CoreProps {}
